



















































import Vue, { PropType } from 'vue';
import { Documents } from '@/types';
import { getPhaseCompletionStatus, getPhaseIcon } from '@/util';
import { downloadFile } from '../services/service';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'MyDocumentsListItem',
  props: {
    document: {
      type: Object as PropType<Documents>,
      required: true
    },
    divisionId: {
      type: String,
      required: true
    },
    isInactivejob: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    BytesToSize (size: string) {
      const bytes = parseInt(size);
      const sizes = ['Kb', 'Mb'];
      if (bytes === 0) {
        return 'n/a'
      }
      let unit = Math.floor(Math.log(bytes) / Math.log(1024));
      if (unit <= 1 && unit >= 0) {
        unit = 1;
      } else {
        unit = 2;
      }
      return (bytes / Math.pow(1024, unit)).toFixed(1) + ' ' + sizes[(unit - 1)];
    },
    getDocumentIcon (type: string): string {
      let iconClass = '';
      if (type === 'PDF') {
        iconClass = 'pdf-icon';
      }
      if (type === 'DOC' || type === 'DOCX') {
        iconClass = 'doc-icon';
      }
      if (type === 'XLS' || type === 'XLSX') {
        iconClass = 'exl-icon';
      }
      return iconClass;
    },
    getStatus (value: string) {
      return getPhaseCompletionStatus(value);
    },
    getPhaseIcon (phase: string) {
      return getPhaseIcon(phase);
    },
    async downloadFile (id: string, fileName: string, type: string, title: string) {
      const modalType = await downloadFile(id, fileName, type, this.divisionId);
      this.$emit(EventType.SHOW_NOTIFICATION_MODAL, { modalType, documentTitle: title });
    }
  }
});
